import React from "react";
import { split } from "lodash";
import FileIcon from "components/shared/FileIcon";
import getFileType from "helpers/files/getFileType";
import FolderIcon from "components/shared/FolderIcon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";

export type Link = {
  id: string;
  url: string;
  image_url?: string;
  title?: string;
  description?: string;
  loading?: boolean;
};

type LinkPreviewArgs = {
  link: Link;
  className?: string;
  imageClassName?: string;
};

export default function LinkPreview({ link, imageClassName }: LinkPreviewArgs) {
  const type = split(link.id, "_")[0];

  return (
    <>
      {link.image_url && (
        <div
          className={classNames(
            "w-16 h-16 flex-shrink-0 bg-cover bg-center rounded",
            imageClassName,
          )}
          style={{
            backgroundImage: `url("${link.image_url}")`,
          }}
        />
      )}
      <div className="px-2 py-1 flex flex-col overflow-hidden grow-0">
        <div className="flex gap-2 items-center">
          {type === "file" && (
            <FileIcon
              extension={getFileType(link.title || "")}
              className="flex-shrink-0 text-sm"
            />
          )}
          {type === "folder" && (
            <FolderIcon className="flex-shrink-0 text-sm" />
          )}
          {type === "appointment" && (
            <FontAwesomeIcon
              className="flex-shrink-0 text-sm"
              icon={faCalendar}
            />
          )}
          <a
            className="font-medium text-sm truncate block overflow-hidden text-ellipsis"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {link.title}
          </a>
        </div>
        {link.description && (
          <span className="text-xs text-muted line-clamp-2 text-ellipsis overflow-hidden">
            {link.description}
          </span>
        )}
      </div>
    </>
  );
}
